export default [
  {
    title: 'Campaign',
    komicon: 'k-share-1',
    route: 'notification',
    action: 'manage',
    children: [
      {
        title: 'Notification',
        komicon: 'k-notification',
        tagVariant: 'light-warning',
        route: 'notification',
        resource: 'Campaign - Notification',
        action: 'read',
      },
      {
        title: 'Blast Email',
        komicon: 'k-sms',
        tagVariant: 'light-warning',
        route: 'blast-email',
        resource: 'Campaign - Blast Email',
        action: 'read',
      },
    ],
  },
]
